import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@cbrebuild/blocks';

class FileUploadModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlight: false,
    };
    this.fileInputRef = React.createRef();
    this._preventBrowserDrop = (e) => e.preventDefault();
  }

  componentDidMount() {
    document.addEventListener('dragover', this._preventBrowserDrop);
    document.addEventListener('drop', this._preventBrowserDrop);
  }

  componentWillUnmount() {
    document.removeEventListener('dragover', this._preventBrowserDrop);
    document.removeEventListener('drop', this._preventBrowserDrop);
  }
  handleFilesAdded = (event) => {
    const { disabled, onFilesAdded } = this.props;
    if (disabled) return;
    const { files } = event.target;
    if (onFilesAdded) {
      const array = this.fileListToArray(files);
      onFilesAdded(array);
      if (this.fileInputRef.current && this.fileInputRef.current.value) {
        this.fileInputRef.current.value = null;
      }
    }
  };

  onDrop = (event) => {
    const { disabled, onFilesAdded } = this.props;
    event.preventDefault();
    this.setState({ highlight: false });
    if (disabled) return;
    const { files } = event.dataTransfer;
    if (onFilesAdded && files && files.length) {
      onFilesAdded(this.fileListToArray(files));
    }
  };

  onDragOver = (event) => {
    event.preventDefault();
    if (!this.props.disabled) this.setState({ highlight: true });
  };

  onDragLeave = () => {
    this.setState({ highlight: false });
  };

  // convert the files receieved from FileList
  // to an array so its easier to work with
  fileListToArray = (fileList) => {
    const array = [];
    for (let i = 0; i < fileList.length; i++) {
      array.push(fileList.item(i));
    }
    return array;
  };

  // to actually open the file dialog, click
  // on the input using javascript
  openFileDialog = () => {
    const { disabled } = this.props;
    if (disabled) return;
    this.fileInputRef.current.click();
  };

  render() {
    const { highlight } = this.state;
    const { disabled } = this.props;
    return (
      <React.Fragment>
        <span
          className={`voucherdropzone-zone${highlight ? ' highlight' : ''}`}
          onClick={this.openFileDialog}
          onDrop={this.onDrop}
          onDragOver={this.onDragOver}
          onDragLeave={this.onDragLeave}
          style={{ cursor: disabled ? 'default' : 'pointer' }}
        >
          <input
            ref={this.fileInputRef}
            className="file-input"
            type="file"
            multiple
            onChange={this.handleFilesAdded}
          />
          <span className="voucherdropzone-text">
            <Icon iconName="upload" size="large" className="voucherdropzone-icon" />
            <span className="voucherdropzone-title">Drag files here or click to upload</span>
            <span className="voucherdropzone-sub">Drag and drop, or click to browse</span>
            <span className="voucherdropzone-limit">There is a <strong>5GB</strong> size limit per file.</span>
          </span>
        </span>
      </React.Fragment>
    );
  }
}

FileUploadModal.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onFilesAdded: PropTypes.func.isRequired,
};

export default FileUploadModal;
